import Vue from 'vue'
import i18n from '@/utils/i18n'

export default {
  uppercase:
    Vue.filter('uppercase', function (value) {
      if (!value) return ''
      value = value.toString()
      return value.toUpperCase()
    }),

  lowercase:
    Vue.filter('lowercase', function (value) {
      if (!value) return ''
      value = value.toString()
      return value.toLowerCase()
    }),

  capitalise:
    Vue.filter('capitalise', function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }),

  bool:
    Vue.filter('bool', function (value) {
      if (value === null) return i18n.t('_undefined')
      return value ? i18n.t('_yes') : i18n.t('_no')
    }),

  percent:
    Vue.filter('percent', function (value) {
      // Need a number for calculations
      if (isNaN(value)) value = parseFloat(value.replace(',', '.'))

      // Assume that percent cannot be higher than 100 %
      if (value <= 1) value *= 100

      // If int, do not display decimals
      if (value % 1) value = value.toFixed(2)

      // Need a string for french display with comma
      return `${String(value).replace('.', ',')} %`
    }),

  getLength:
    Vue.filter('getLength', function (value) {
      if (!value) return

      let length = null

      switch (typeof value) {
        case 'object':
          length = Object.keys(value).length
          break
        case 'null':
        case 'undefined':
          length = ''
          break
        default:
          length = value.length
      }

      return length
    }),

  nl2br:
    Vue.filter('nl2br', function (value) {
      if (value === undefined || value === null) return

      return String(value).replaceAll('\n', '<br />')
    })
}
